<div *ngIf="errorText" class="invalid-feedback-section" [class.hide-control]="hideError">
    <div class="invalid-feedback">
        {{ errorText }}
    </div>
</div>
